<template>
  <div class="h-100 px-4">
    <div class="pb-2">
      <VSkeletonLoader
        class="h-100"
        type="image"
      />
    </div>
    <div class="d-flex h-100">
      <div class="d-flex flex-column justify-content-between w-100">
        <div class="pb-10">
          <VSkeletonLoader 
            type="card-heading" 
            class="w-50"
          />
          <VSkeletonLoader
            type="divider"
            class="pb-10"
          />
          <VSkeletonLoader
            type="list-item-three-line"
            class="pb-5" />
          <VSkeletonLoader type="list-item-two-line" />
        </div>
        <div class="pb-2">
          <VSkeletonLoader type="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SSearchResultDialogSkeletonLoader',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useVuetify } from '../../../composables';

const vuetify = useVuetify();

const isMobile = computed(() => vuetify.breakpoint.xs);
</script>
<style lang="scss" scoped>

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading {
    .v-skeleton-loader__image {
      height: 285px !important;
    }

    .v-skeleton-loader__heading {
        width: unset !important;
    }
}
</style>
